import { filterNotUndefined } from 'annotation-tools/utils';
import { ReplaySubject } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';

/* koumutenId */
const koumutenIdSource = new ReplaySubject<number | undefined>(1);
export const updateKoumutenId = (id: number | undefined | undefined) =>
  koumutenIdSource.next(id);
export const nullableKoumutenId$ = koumutenIdSource
  .asObservable()
  .pipe(distinctUntilChanged(), shareReplay(1));
export const koumutenId$ = nullableKoumutenId$.pipe(
  filterNotUndefined(),
  shareReplay(1)
);

/* companyId */
const companyIdSource = new ReplaySubject<number | undefined>(1);
export const updateCompanyId = (id: number | undefined) =>
  companyIdSource.next(id);
export const nullableCompanyId$ = companyIdSource
  .asObservable()
  .pipe(distinctUntilChanged(), shareReplay(1));
export const companyId$ = nullableCompanyId$.pipe(
  filterNotUndefined(),
  shareReplay(1)
);

/* modelId */
const modelIdSource = new ReplaySubject<number | undefined>(1);
export const updateModelId = (id: number | undefined) => modelIdSource.next(id);
export const nullableModelId$ = modelIdSource
  .asObservable()
  .pipe(distinctUntilChanged(), shareReplay(1));
export const modelId$ = nullableModelId$.pipe(
  filterNotUndefined(),
  shareReplay(1)
);

/* projectId */
const projectIdSource = new ReplaySubject<number | undefined>(1);
export const updateProjectId = (id: number | undefined) =>
  projectIdSource.next(id);
export const nullableProjectId$ = projectIdSource
  .asObservable()
  .pipe(distinctUntilChanged(), shareReplay(1));
export const projectId$ = nullableProjectId$.pipe(
  filterNotUndefined(),
  shareReplay(1)
);

/* imageId */
const imageIdSource = new ReplaySubject<number | undefined>(1);
export const updateImageId = (id: number | undefined) => imageIdSource.next(id);
export const nullableImageId$ = imageIdSource
  .asObservable()
  .pipe(distinctUntilChanged(), shareReplay(1));
export const imageId$ = nullableImageId$.pipe(
  filterNotUndefined(),
  shareReplay(1)
);
